export function isValidUserGroup(str: string) {
  const regex = /^10[1-9]|11\d|12\d|13\d|14\d|15\d|160$/
  return regex.test(str)
}
